import { SupportAdminCheckComponent } from "../../../components/SupportSystem/Admin/SupportAdminCheckComponent"
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function SupportAdminCheckContainer () {
    const titleName = "รายละเอียดคำขอรับเงินช่วยเหลือหรืออุดหนุน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem  />
            <HeadTitle title={titleName} />
            <SupportAdminCheckComponent/>
            <Footer />
        </div>   
    )
}